import { PageLayout } from '@/common/layouts/PageLayout.tsx'
import { useSelector } from 'react-redux'
import { RootState } from '@/redux/store.ts'
import Title from 'antd/es/typography/Title'
import { DevPanel } from '@/common/components/DevPanel.tsx'
import { HomePeopleSection } from '@/pages/home/HomePeopleSection.tsx'


export const IndexPage = () => {
  const { user } = useSelector((state: RootState) => state.auth)

  // Get the current hour (0-23)
  const currentHour = new Date().getHours()

  let greeting
  if (currentHour >= 5 && currentHour < 12) {
    greeting = 'Good morning'
  } else if (currentHour >= 12 && currentHour < 18) {
    greeting = 'Good afternoon'
  } else {
    greeting = 'Good evening'
  }

  return (
    <PageLayout>
      <Title level={3}>{greeting}, {user?.name.toUpperCase()}</Title>
      <DevPanel />
      <HomePeopleSection />
    </PageLayout>
  )
}
